import PropTypes from "prop-types";
import Slider from "rc-slider";
import "./RangeInput.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range); // Utiliser createSliderWithTooltip pour créer un composant Range avec une infobulle intégrée
const SliderWithTooltip = createSliderWithTooltip(Slider); // Créer un composant Slider avec une infobulle intégrée

const RangeInput = ({
	range = true,
	defaultValue,
	min = 0,
	max,
	step = 1,
	label,
	onValueChange,
	tipFormatter,
}) => {
	const formatTooltipValue = value => {
		const numericValue = Number(value);
		if (numericValue === Number(min) || numericValue === Number(max)) {
			return null;
		}

		const formattedValue = tipFormatter ? tipFormatter(value) : value;
		const content = formattedValue ?? value;
		return <Typography variant={TYPOGRAPHY_VARIANTS.REGULAR}>{content}</Typography>;
	};

	return (
		<div className="range-input">
			<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} className="range-input__label">
				{label}
			</Typography>
			<div className="range-input__element">
				{range ? (
					<Range
						defaultValue={defaultValue}
						allowCross={false}
						step={Number(step)}
						min={Number(min)}
						max={Number(max)}
						tipFormatter={formatTooltipValue}
						tipProps={{ placement: "bottom", visible: true }}
						onAfterChange={value => {
							onValueChange(value);
						}}
					/>
				) : (
					<SliderWithTooltip
						defaultValue={defaultValue}
						step={Number(step)}
						min={Number(min)}
						max={Number(max)}
						tipFormatter={formatTooltipValue}
						tipProps={{ placement: "bottom", visible: true }}
						onAfterChange={value => {
							onValueChange(value);
						}}
					/>
				)}
			</div>
		</div>
	);
};

RangeInput.propTypes = {
	defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	min: PropTypes.number,
	max: PropTypes.number,
	step: PropTypes.number,
	onValueChange: PropTypes.func,
	range: PropTypes.bool,
	tipFormatter: PropTypes.any,
};

export default RangeInput;
